import React from 'react';
import AppRouter from '@components/AppRouter';

const App = () => {
  return <AppRouter />;
};

export default App;
